import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "0",
    width: "100%",
    height: "100%",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
  }
}));

const AlphaGraf = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <iframe src="https://graficos.alphaaeduc.com.br" className={classes.iframe} title="AlphaGRAF" />
    </div>
  );
};

export default AlphaGraf;
